<footer class="container d-flex justify-content-center mb-5" [ngClass]="{'loading': (isLoading$ | async)}">
  <div class="row col-lg-6 col-sm-12">
    <h3 class="h6 mb-3">{{title | async}}</h3>
    <div *ngIf="!errorMsg && details" class="small text-muted" [innerHTML]="details.relet.portalFooterContent">
    </div>
    <p *ngIf="!!errorMsg" class="text-danger font-italic">{{errorMsg | async}}</p>
  </div>
</footer>
